import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-download-clip',
  templateUrl: './download-clip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DownloadClipComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
